import { createMuiTheme } from '@material-ui/core/styles'
import purple from '@material-ui/core/colors/purple';
import green from '@material-ui/core/colors/green';
import yellow from '@material-ui/core/colors/yellow';
import cyan from '@material-ui/core/colors/cyan';
import red from '@material-ui/core/colors/red';
import grey from '@material-ui/core/colors/grey';
import amber from '@material-ui/core/colors/amber';
export const theme = createMuiTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1920,
            phone: 415,
        }
    },
    palette: {
        type: 'dark',
        primary: {
            //main: purple[900],
            //main: yellow[700],
            //main: cyan["A200"],
            main: grey[900],
        },
        secondary: {
            main: red[500],
        },
        datavis: {
            //main: grey[200]
            main: amber[500]
        }
        //"common": {
        //    "black": "#000",
        //    "white": "#fff"
        //},
        //"background": {
        //    "paper": "#fff",
        //    "default": "#fafafa"
        //},
        //"primary": {
        //    "light": "rgba(89, 210, 188, 1)",
        //    "main": "rgba(20, 160, 140, 1)",
        //    "dark": "rgba(0, 113, 95, 1)",
        //    "contrastText": "#fff"
        //}

    },
    overrides: {
        //MuiButton: {
        //    label: {
        //        color: 'black',
        //    }
        //},
        //MuiButton: {
        //    containedPrimary: {
        //        color: 'black',
        //    },
        //},
    }
});
export default theme;